export const CONSENT_STORAGE_KEY = 'cgr_consent';
export const CONSENT_VERSION = 1;
export const CONSENT_MAX_AGE_MS = 365 * 24 * 60 * 60 * 1000;
export const CONSENT_CHANGED_EVENT = 'cgr-consent-changed';

const hasGpcSignal = () => typeof navigator !== 'undefined' && navigator.globalPrivacyControl === true;

const readSavedConsent = () => {
  if (typeof window === 'undefined') return null;

  try {
    const raw = JSON.parse(window.localStorage.getItem(CONSENT_STORAGE_KEY));
    if (!raw || typeof raw !== 'object') return null;
    if (!raw.ts || Date.now() - raw.ts > CONSENT_MAX_AGE_MS) return null;
    return raw;
  } catch (error) {
    return null;
  }
};

export const resolveConsent = () => {
  const saved = readSavedConsent();
  const gpc = hasGpcSignal();

  const consent = {
    analytics: saved ? Boolean(saved.analytics) : true,
    ads: saved ? Boolean(saved.ads) : true,
    optout: saved ? Boolean(saved.optout) : false,
    gpc,
  };

  if (gpc) {
    consent.ads = false;
    consent.optout = true;
  }

  return consent;
};

export const pushConsentUpdate = (consent) => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'consent_update',
    analytics_storage: consent.analytics ? 'granted' : 'denied',
    ad_storage: consent.ads ? 'granted' : 'denied',
    ad_user_data: consent.ads ? 'granted' : 'denied',
    ad_personalization: consent.ads ? 'granted' : 'denied',
  });

  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      analytics_storage: consent.analytics ? 'granted' : 'denied',
      ad_storage: consent.ads ? 'granted' : 'denied',
      ad_user_data: consent.ads ? 'granted' : 'denied',
      ad_personalization: consent.ads ? 'granted' : 'denied',
    });
  }
};

export const saveConsent = (partial) => {
  const gpc = hasGpcSignal();
  const previous = window.CGR_CONSENT || resolveConsent();

  const next = {
    analytics: partial.analytics ?? previous.analytics,
    ads: gpc ? false : partial.ads ?? previous.ads,
    optout: gpc ? true : partial.optout ?? previous.optout,
    gpc,
  };

  window.CGR_CONSENT = next;

  try {
    window.localStorage.setItem(
      CONSENT_STORAGE_KEY,
      JSON.stringify({ v: CONSENT_VERSION, ts: Date.now(), analytics: next.analytics, ads: next.ads, optout: next.optout })
    );
  } catch (error) {
    // no-op — private browsing / storage disabled
  }

  pushConsentUpdate(next);
  window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT, { detail: next }));

  return next;
};

export const isAdsAllowed = () => {
  if (typeof window === 'undefined') return false;
  return Boolean(window.CGR_CONSENT?.ads);
};
